app.service("ComponentService", ['$rootScope', function ($rootScope) {

    const service = this;

    const modelConstructor = $rootScope.model_constructor;

    const RouteChoice = modelConstructor.RouteChoice;

    const ComponentModel = modelConstructor.extend(modelConstructor.RouteModel, {
        name: "Component",
        id: "component",
        navigation_pointer: "component_id",
        choice_is_breadcrumb: true
    });

    this.factory = new modelConstructor.RouteFactory({

        choices: {

            door: new RouteChoice({
                public_id: "door_drawer",
                name: "Doors & Drawers",
                next_model_id: "tile"
            }),
            hettich: new RouteChoice({
                public_id: "hinge_drawer_accessory",
                name: "Hinges & Drawer boxes",
                next_model_id: "tab"
            }),
            handle_rail: new RouteChoice({
                name: "Handles and Rails",
                next_model_id: "tab"
            }),
            component_accessory: new RouteChoice({
                public_id: "general_accessory",
                name: "General Accessories"
            }),

            panel: new RouteChoice({
                public_id: "bella_panel",
                name: "Bella Panels",
            }),
            stock_panel: new RouteChoice({
                public_id: "other_panel",
                name: "Other Panels"
            }),
            stock_plinth: new RouteChoice({
                public_id: "plinth",
                name: "Plinths"
            }),

            cabinet_kitchen: new RouteChoice({
                name: "Kitchen Cabinets",
                next_model_id: "clicbox_colour"
            }),
            cabinet_bedroom: new RouteChoice({
                name: "Bedroom Cabinets",
                next_model_id: "clicbox_colour"
            }),
            door_sloping: new RouteChoice({
                public_id: "sloping_door",
                name: "Sloping Doors"
            }),
            frame: new RouteChoice({
                name: "Frames",
                next_model_id: "tile"
            }),
            stock_curved: new RouteChoice({
                public_id: "curved_door",
                name: "Curved Doors",
                state_ids: {
                    base_component_id: "stock",
                    parent_category_id: "curved"
                }
            }),
            wrap: new RouteChoice({
                name: "Wrap Panels",
                next_model_id: "tile"
            }),

            promotional: new RouteChoice({
                name: "Marketing",
                next_model_id: "tile"
            }),


            solution_cabinet: new RouteChoice({
                public_id: "cabinet",
                name: "Cabinets",
                next_model_id: "method_product"
            }),
            select_accessory: new RouteChoice({
                name: "Accessories",
                next_model_id: "select"
            }),
            panel_wrap: new RouteChoice({
                name: "Panels & Wrap Panels",
                next_model_id: "tile"
            }),

            solution_extra: new RouteChoice({
                public_id: "extra",
                name: "Appliance Doors",
                next_model_id: "tab"
            })
        },

        birth: function (values) {
            return new ComponentModel(values);
        },

        applyModelVariation: applyModelVariation
    });


    function applyModelVariation(model) {

        this.super(model);

        const variationIDs = model.variation_ids;
        const browseID = variationIDs.browse_id;
        const solutionID = variationIDs.solution_id;
        const requestRangeID = variationIDs.request_range_id;
        const siteRangeID = variationIDs.site_range_id;

        let cacheChoiceList = [];
        let previousChoiceIsBreadcrumb = false;


        let choiceOrder = [];

        function overrideListIDs(list, ids) {
            for (let fromID in ids) {
                const toID = ids[fromID];
                for (let j = 0; j < list.length; j++) {
                    const item = list[j];
                    if (item.id === fromID) {
                        item.id = toID;
                        break;
                    }
                }
            }
        }

        const applyToChoices = {};

        if (browseID === "component") {

            choiceOrder = ['door', 'solution_cabinet', 'panel', 'stock_panel', 'stock_plinth', 'hettich', 'handle_rail', 'component_accessory', 'cabinet_kitchen', 'cabinet_interior', 'cutlery', 'cabinet_bedroom', 'door_sloping', 'frame', 'stock_curved', 'wrap', 'clearance', 'promotional'];
            cacheChoiceList = $rootScope.service.cache_local_server.getParentCategoryChoiceList("stock", ["cabinet_interior", "cutlery", "clearance"]);
            applyToChoices.cabinet_interior = {next_model_id: "collection_product"};
            applyToChoices.cutlery = {next_model_id: "collection_product"};
            applyToChoices.solution_cabinet = {public_id: 'cabinet_matrix', name: "Cabinet Matrix"};
            applyToChoices.clearance = {next_model_id: "collection_product"};

        } else if (browseID === "site_range") {

            previousChoiceIsBreadcrumb = true;


            if (requestRangeID === "pronto") {

                choiceOrder = ['door', 'select_accessory', 'handle_rail'];

            } else if (requestRangeID === "valore") {

                choiceOrder = ['door', 'wrap', 'select_accessory', 'handle_rail'];

            } else if (requestRangeID === "bella") {

                choiceOrder = ['door', 'frame', 'stock_curved', 'select_accessory', 'panel_wrap', 'handle_rail'];
                applyToChoices.stock_curved = {next_model_id: "collection_product"};

            } else if (requestRangeID === "zurfiz") {

                choiceOrder = ['door', 'select_accessory', 'site_range_panel', 'wrap', 'handle_rail'];
                cacheChoiceList = $rootScope.service.cache_local_server.getParentCategoryChoiceList("stock", ["panel"]);
                overrideListIDs(cacheChoiceList, {panel: "site_range_panel"});
                applyToChoices.site_range_panel = {next_model_id: "collection_product"};
            }
            applyToChoices.panel_wrap = {name: "Panels & Tops + Wrap Panels"};
            applyToChoices.handle_rail = {name: "Handles"};
        } else if (browseID === "solution") {

            if (solutionID === "kitchen_rigid_flat_pack" && (siteRangeID === "jayline" || siteRangeID === "lacarre")) {
                choiceOrder = ['solution_cabinet', 'solution_extra', 'select_accessory'];
            } else {
                choiceOrder = ['solution_cabinet', 'solution_extra', 'select_accessory', 'handle_rail'];
            }

            let solution_extra_name = null;
            if (solutionID === "kitchen_rigid_flat_pack") {
                if (requestRangeID === "bella") {
                    solution_extra_name = "Panels & Appliance Doors"
                }
            } else if (solutionID === "kitchen_inrail") {
                if (requestRangeID === "bella") {
                    solution_extra_name = "Panels, Wrap Panels & Appliance Doors"
                } else {
                    solution_extra_name = "Wrap Panels & Appliance Doors"
                }
            } else if (solutionID === "bedroom_flat_pack") {
                solution_extra_name = "End Panel Packs, Panels & Plinths"
            }

            if (solution_extra_name) {
                applyToChoices.solution_extra = {name: solution_extra_name};
            }

            if (solutionID !== "kitchen_inrail") {
                applyToChoices.handle_rail = {public_id: "handle", name: "Handles"};
            } else {
                applyToChoices.handle_rail = {public_id: "handleless_rail", name: "Handleless Rails"};
            }
            if (solutionID === "bedroom_flat_pack") {
                applyToChoices.solution_cabinet = {next_model_id: "tab"};
            }
        }

        const choices = $rootScope.site_helper.cloneChoices(service.factory.choices, choiceOrder);
        for (let i = 0; i < cacheChoiceList.length; i++) {
            const choice = cacheChoiceList[i];
            choices[choice.id] = choice;
        }


        for (let choiceID in choices) {
            const choice = choices[choiceID];
            choice.state_values.component_name = choice.name;

            if (browseID === "component") {
                if ([
                    'component_accessory',
                    'panel',
                    'stock_panel',
                    'stock_plinth',
                    'door',
                    'door_sloping',
                    'frame',
                    'stock_curved',
                    'wrap'
                ].includes(choice.id)) {
                    choice.next_model_id = "method_input";
                }
            }
            if (requestRangeID === "pronto") {
                if (choice.id === 'select_accessory') {
                    choice.name = "Feature Doors & Accessories";
                }
            }
            const toApply = applyToChoices[choiceID];
            if (toApply) {
                for (let key in toApply) {
                    choice[key] = toApply[key];
                }
            }
        }

        model.choices = choices
        model.choice_order = choiceOrder;
        model.previous_choice_is_breadcrumb = previousChoiceIsBreadcrumb;

    }

}]);